<template>
  <div>
    <password ref="passwordRef"></password>
  </div>
</template>

<script>
import password from '@/views/password.vue';
export default {
  components: {
    password
  },
  data() {
    return {
      appid: 'wx596807efa16908ce',
      username: '',
      password: '',
      code: '',
      openId: '',

      passwordVisible: false
    }
  },
  created() {
    this.getOpenIdData();
  },
  methods: {
    getOpenIdData() {
      this.code = this.$route.query.code;
      /**
       * 通过返回的code获取openId
       * 后台根据openId获取用户，获取匹配到了则直接调用登录接口，未匹配到则回到登录页
       */
      let params = {
        code: this.code
      }
      this.$http.get(this.$API.wechat_getUserByCode, { params }).then(res => {
        if (res.success) {
          this.openId = res.data.openid || '';
          let wxName = res.data.nickname || '';
          let wxUrl = res.data.headimgurl || '';
          sessionStorage.setItem('openId', this.openId);
          sessionStorage.setItem('wxName', wxName);
          sessionStorage.setItem('wxUrl', wxUrl);
          this.getUserInfoData();
        } else {
          this.$router.push({ path: '/login' });
        }
      })
    },
    getUserInfoData() {
      let params = {
        openId: this.openId
      }
      this.$http.get(this.$API.user_findListByOpenId, { params }).then(res => {
        if (res.success) {
          this.username = res.data.userName;
          this.password = res.data.password;
          this.login();
        } else {
          this.$router.push({ path: '/login' });
        }
      })
    },
    login() {
      let params = {
        username: this.username,
        password: this.password,
        openId: this.openId
      };
      this.$http.post(this.$API.mlyun_auth_server_auth_safelogin, params).then(async ({ success, data, errCode, message }) => {
        if (success) {
          sessionStorage.setItem('token', data.token);
          this.$store.dispatch('app/updateLoginInfo', {
            userInfo: data,
          });
          sessionStorage.setItem('userInfo', JSON.stringify(data));
          this.$router.push({ path: '/home' });
        } else {
          if (errCode == 'PASSWORD_EXPIRE') {
            this.$message.error(message);
            this.$refs.passwordRef.openModal(this.username, 'verity');
          }
        }
      }).catch(() => {

      });
    }
  }
}
</script>